import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {getfoliotransactionledger,gettransactiondetailsbyaudit,getInvoiceDetailsById,getBillDetailsById } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { Button, message,Table } from "antd";
import moment from "moment";
import CustomModal from "../../../input-components/Modal";
import ShowValue from "../../../input-components/ShowValue";
import { format } from 'date-fns';
import "./folio.css";


const Folio = () => {
  const navigate = useNavigate();
  const { showSpinner, hideSpinner } = useSpinnerContext();
  const [ownerFolioLists, setOwnerFolioLists] = useState([]);
  const [allDetails, setAllDetails] = useState({});
  const [purpose, setPurpose] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rows, setRows] = useState(10);
  const [viewTransactionDetails ,setViewTransactionDetails] = useState(false)
  const [getDetails, setGetDetails] = useState(null);
 
  // Extract query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const folioType = urlParams.get("type");
  const folio = urlParams.get("folio");

  // Extract user data from cookies
  const userData = GetCookie("@UserData");
  const { agencyID, userId } = userData ? JSON.parse(userData) : {};

  useEffect(() => {
    if (userId) {
      getSupportList(folio,currentPage);
    }
  }, [userId, purpose]);

  const getSupportList = (folio,currentPage) => {
    const baseUrl = getfoliotransactionledger;
    const requestData = addParametersForProfiles({
      AgencyId: agencyID,
      Folio: folio,
      TabId: purpose,
      PageNo: currentPage,
    });
  
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", requestData)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          setAllDetails(response.object);
          setTotalPages(response.totalCount)
          let dataList = [];

          if (purpose === 3 && folioType === "Owner"|| purpose === 4 && folioType === "Owner"||folioType === "Supplier" && purpose === 3 ) {
            dataList = response.object.bills?.map((item) => ({
              bill: item.id,
              supplier: item.supplierName,
              property: item.propertyAddress,
              ref: item.reference,
              due: moment(item.dueDate).format("DD/MM/YYYY"),
              account: item.accountChart,
              detail: item.details,
              tax: item.isTax ? "Yes" : "No",
              amount: item.amount,
              uid:item.uid,
              attachment : item.isAttached
            })) || [];
          } 
          else if (folioType === "Tenant" && purpose === 3 || folioType === "Tenant" && purpose === 4 || purpose === 5 && folioType === "Owner") {
            dataList = response.object.invoices?.map((item) => ({
              invoices: item.id,
              due: moment(item.date).format("DD/MM/YYYY"),
              account: item.accountChart,
              details: item.details,
              Tax: item.isTax ? "Yes" : "No",
              amount: item.amount,
              paidAmount: item.paidAmount,
              uid:item.uid
            })) || [];
          } 
          else {
            dataList = response.object.ledgerTransaction?.map((item) => ({
              auditNumer: item.auditNumer,
              createdAt: moment(item.createdAt).format("DD/MM/YYYY"),
              reference: item.reference,
              Type: item.sType,
              propertyAddress: item.propertyAddress,
              summary: item.summary,
              debit: item.debit ? `$${item.debit}` : "",
              credit: item.credit ? `$${item.credit}` : "",
            })) || [];
          }  
          setOwnerFolioLists(dataList);
        } else {
          message.error(response.message);
        }
      })
      .catch((error) => console.error("Error:", error));
  };
  
  const handlePageChange = (pageNumber, totalRows) => {
    setCurrentPage(pageNumber);
    setRows(totalRows);
    getSupportList(folio,pageNumber);
  };

  const renderFinancialButtons = (type) => {
    const isNumber = (val) => typeof val === "number" || (!isNaN(val) && val !== "");
    const financialData = type === "Owner"
      ? [
          { label: "Opening", value: allDetails?.openingBal },
          { label: "Money In", value: allDetails?.moneyIn },
          { label: "Money Out", value: allDetails?.moneyOut },
          { label: "Withhold", value: allDetails?.without },
          { label: "Uncleared", value: allDetails?.uncleared },
          { label: "Balance", value: allDetails?.balance },
        ]
      : [
          { label: "Paid To", value: moment(allDetails?.tenantFolioDetails?.paidTo ).format("DD MM YYYY")},
          { label: "Part Paid", value: allDetails?.tenantFolioDetails?.partPaid },
          { label: "Deposits", value: allDetails?.tenantFolioDetails?.deposit },
          { label: "Uncleared", value: allDetails?.uncleared },
          { label: "Bond Held", value: allDetails?.tenantFolioDetails?.bondHeld },
        ];

        return (
          <div className="financial-summary-cards">
            {financialData.map((btn, index) => (
              <div className="summary-card" key={index}>
                <div className="summary-label">{btn.label}</div>
                <div className="summary-value">
                  {btn.value !== undefined && btn.value !== "" && (isNumber(btn.value) ? `$${Number(btn.value).toLocaleString()}` : btn.value)}
                </div>
              </div>
            ))}
          </div>
        );
        
  };

  const renderNavigation = (options) => (
    <div>
      {options.map((opt) => (
        <span
          key={opt.id}
          className={`stat-items ${purpose === opt.id ? "active" : ""}`}
          onClick={() => setPurpose(opt.id)}
        >
          {opt.label}
        </span>
      ))}
    </div>
  );

  const ownerNavOptions = [
    { id: 1, label: "Current Transactions" },
    { id: 2, label: "All Transactions" },
    { id: 3, label: "Pending Bills" },
    { id: 4, label: "Paid Bills" },
    { id: 5, label: "Pending Invoice" },
  ];

  const otherNavOptions = [
    { id: 1, label: "Current Month" },
    { id: 2, label: "All Transactions" },
    { id: 3, label: "Pending Invoices" },
    { id: 4, label: "Paid Invoice" },
    { id: 5, label: "Rent Actions" },
  ];

  const actions = [
    { icon: "/assets/images/dots.svg",key:"View" },
    // { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
]

  const GetDetailsApiTransaction = (data) => {
                        const url = gettransactiondetailsbyaudit + `?AuditId=${data}`;
                        makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
                            .then((response) => {
                                if (response.status === ActionStatus.Successfull) {
                                    setGetDetails(response.object);
                                }
                            })
                            .catch((error) => {
                                console.error("Error fetching ticket details:", error);
                            })
                            .finally(() => {
                                //setLoading(false); // Set loading to false once API call completes
                            });
                    };

                    const viewTransactionDetail = (e, data) => {
                        setGetDetails(null)
                        if (
                            (folioType === "Tenant" || folioType === "Owner") && (purpose === 1 || purpose === 2)
                        ) {
                            GetDetailsApiTransaction(data.auditNumer);
                            setViewTransactionDetails(true);

                        } else if (
                            folioType === "Tenant" && (purpose === 3 || purpose === 4)
                        ) {
                            GetDetailsApiInvoice(data.uid);
                            setViewTransactionDetails(true);

                        } else if (
                            folioType === "Owner" && (purpose === 3 || purpose === 4)
                        ) {
                            GetDetailsApiBills(data.uid);
                            setViewTransactionDetails(true);

                        }
                    };
                    

    const closeViewTrasaction = () => {
        setViewTransactionDetails(false)
    }

    const columns = [
        {
          title: "Contact",
          dataIndex: "contactName",
          key: "contactName",
          render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
        },
        {
          title: "Folio",
          dataIndex: "folio",
          key: "folio",
          render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
        },
        {
          title: "Chart Account",
          dataIndex: "accountChart",
          key: "accountChart",
        },
        {
          title: "Detail",
          dataIndex: "details",
          key: "details",
        },
        {
          title: "Tax",
          dataIndex: "tax",
          key: "tax",
          render: (value) => (value ? "Yes" : "No"),
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          render: (amount) => `$${amount.toFixed(2)}`,
        },
      ];

      const columnsInv = [
        {
            title: "Contact",
            dataIndex: "tenantName",
            key: "tenantName",
            render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
        },
        {
            title: "Folio",
            dataIndex: "folio",
            key: "folio",
            render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
        },
        {
            title: "Chart Account",
            dataIndex: "accountName",
            key: "accountName",
        },
        {
            title: "Detail",
            dataIndex: "details",
            key: "details",
        },
        {
            title: "Tax",
            dataIndex: "isTax",
            key: "isTax",
            render: (value) => (value ? "Yes" : "No"),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => `$${amount.toFixed(2)}`,
        },
    ];

        const GetDetailsApiInvoice = (invoiceId) => {
              const url = getInvoiceDetailsById + `?InvoiceId=${invoiceId}`;
              makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
                  .then((response) => {
                      if (response.status === ActionStatus.Successfull) {
                          setGetDetails(response.object);
                      }
                  })
                  .catch((error) => {
                      console.error("Error fetching ticket details:", error);
                  })
                  .finally(() => {
                      //setLoading(false); // Set loading to false once API call completes
                  });
          };

           const GetDetailsApiBills = (BillId) => {
                          const url = getBillDetailsById + `?BillId=${BillId}`;
                          makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
                              .then((response) => {
                                  if (response.status === ActionStatus.Successfull) {
                                      setGetDetails(response.object);
                                  }
                              })
                              .catch((error) => {
                                  console.error("Error fetching ticket details:", error);
                              })
                              .finally(() => {
                                  //setLoading(false); // Set loading to false once API call completes
                              });
                      };

          const invoiceData = getDetails
          ? [
              {
                  key: getDetails?.id,
                  tenantName: getDetails?.tenantName || "N/A",
                  folio: getDetails?.folio || "N/A",
                  accountName: getDetails?.accountName || "N/A",
                  details: getDetails?.details || "N/A",
                  isTax: getDetails?.isTax,
                  amount: getDetails?.amount || 0,
              },
          ]
          : [];

          const billData = getDetails
          ? [
              {
                key: getDetails?.id,
                ownerName: getDetails?.ownerName || "N/A",
                folio: getDetails?.ownerFolio || "N/A",
                accountName: getDetails?.accountChart || "N/A",
                details: getDetails?.details || "N/A",
                isTax: getDetails?.isTax,
                amount: getDetails?.amount || 0,
              },
            ]
          : [];


          const title =
          ((purpose === 1 || purpose === 2))
            ? `${getDetails?.transactionType} #${getDetails?.referenceId} - ${getDetails?.paymentDescription}`
            : (folioType === "Tenant" && (purpose === 3 || purpose === 4))
              ? `Invoice #${getDetails?.id} - ${getDetails?.details}`
              : (folioType === "Owner" && (purpose === 3 || purpose === 4)) ?  `Bill #${getDetails?.id} - ${getDetails?.details}` : "";

              const handleProperty = (data) => {
                navigate(`/agency/viewPropertyDetails?propertyUID=${data}`);
            }

                  
  return (
    <div className="px-0 changedateantdstyle">
      <SubNav
        title={`${folioType} Folio - ${
          folioType !== "Owner" ? allDetails.folioReferencce : ""
        } (${folio})`}
        goback={true}
        extraData={true}
      />
      <div className="material-work-desk-new bg-white m-3">

        {folioType === "Owner" || folioType === "Supplier" ? renderNavigation(ownerNavOptions) : renderNavigation(otherNavOptions)}
        {renderFinancialButtons(folioType)}

        <AntdTableExample
          showCheckbox
          label={`List ${folioType} Folio`}
          dataSource={ownerFolioLists}
          globalSearch
          hideCol={"id,uid"}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          totalRows={rows}
          totalRecords={totalPages}
          actions={actions}
          onRowClick={viewTransactionDetail}
        />
      </div>
        
      <CustomModal footer={null} title={title} width={1000} closable={closeViewTrasaction} visible={viewTransactionDetails} onCancel={closeViewTrasaction}
                        modalData={
                            <div>
                                {((purpose === 1 )||(purpose === 2)) ?
                                <div className="details-form p-3">
                                    <div className="contacts-group">
                                        <ShowValue Label='Created Date' setData={getDetails?.createdAt ? format(new Date(getDetails.createdAt), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        <ShowValue Label='Paid By' setData={getDetails?.paidBy} />
                                        <ShowValue Label='Transaction Date' setData={getDetails?.transactionDate ? format(new Date(getDetails.transactionDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                                        <ShowValue Label='Processed By' setData={getDetails?.processedBy} />

                                        <h6 style={{ marginTop: "20px" }}>Transaction Details</h6>
                                        <Table columns={columns} dataSource={getDetails?.transactionsDetails} pagination={false} />

                                        <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                            Total: ${getDetails?.totalAmount ? getDetails.totalAmount.toFixed(2) : "0.00"}
                                        </div>
                                    </div>
                                </div>
                                 : 
                                 (folioType === "Tenant" && purpose === 3 ||folioType === "Tenant" && purpose === 4) ?
                                        <div className="details-form p-3">
                                            <div className="contacts-group">
                                                <ShowValue Label='Created Date' setData={getDetails?.addedOn ? format(new Date(getDetails.addedOn), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='Issued By' setData={getDetails?.issueByFolio} onClick={() => handlefolio("Owner", getDetails?.issueByFolio)} link={true} />
                                                <ShowValue Label='Due Date' setData={getDetails?.date ? format(new Date(getDetails.date), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='Property' setData={getDetails?.propertyName ? getDetails?.propertyName : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                                                {getDetails?.attachment_Path && (
                                                    <div className={`row`}>
                                                        <div className={"label"}>
                                                            <div style={{ color: "#5E696E", fontWeight: '500' }}>{"Document"}:</div>
                                                        </div>
                                                        <div className={"value"} style={{ cursor: 'pointer' }} onClick={handleDownload}>
                                                            {extractFileName(getDetails.attachment_Path)}
                                                            <span className="ml-2 icon" title="Download"><FaDownload /></span>
                                                        </div>
                                                    </div>
                                                )}
                                                <h6 style={{ marginTop: "20px" }}>Invoice Details</h6>
                                                <Table columns={columnsInv} dataSource={invoiceData} pagination={false} />

                                                {/* Total Section */}
                                                <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                                    Total: ${getDetails?.amount ? getDetails.amount.toFixed(2) : "0.00"}
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="details-form p-3">
                                            <div className="contacts-group">
                                                <ShowValue Label='Created Date' setData={getDetails?.addedOn ? format(new Date(getDetails.addedOn), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='reference' setData={getDetails?.reference ? getDetails?.reference : "N/A"} />
                                                <ShowValue Label='supplier' setData={getDetails?.supplierName ? getDetails?.supplierName : "N/A"} />
                                                <ShowValue Label='Due Date' setData={getDetails?.dueDate ? format(new Date(getDetails.dueDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                                                <ShowValue Label='Processed By' setData={getDetails?.processedBy ? getDetails?.processedBy : "N/A"} />
                                                {getDetails?.attachment && (
                                                    <div className={`row`}>
                                                        <div className={"label"}>
                                                            <div style={{ color: "#5E696E", fontWeight: '500' }}>{"Document"}:</div>
                                                        </div>
                                                        <div className={"value"} style={{ cursor: 'pointer' }} onClick={handleDownload}>
                                                            {extractFileName(getDetails.attachment)}
                                                            <span className="ml-2 icon" title="Download"><FaDownload /></span>
                                                        </div>
                                                    </div>
                                                )}
                                                <h6 style={{ marginTop: "20px" }}>Bill Details</h6>
                                                <Table columns={columns} dataSource={billData} pagination={false} />

                                                {/* Total Section */}
                                                <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                                    Total: ${getDetails?.amount ? getDetails.amount.toFixed(2) : "0.00"}
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                        }

                    />
    </div>
  );
};

export default Folio;
